// extracted by mini-css-extract-plugin
export default {"spendPage":"SpendPage_spendPage__pSUNO","header":"SpendPage_header__BMy6y","list_actions":"SpendPage_list_actions__gx-A2","content":"SpendPage_content__XSiaB"};